import Localization from 'lib/localization';

export default {
  get lxHeaderItemLabelShop() {
    return Localization.get('bumblesite@LAYOUT.HEADER.THE_SHOP');
  },

  get lxHeaderItemLabelApp() {
    return Localization.get('bumblesite@LAYOUT.FOOTER.THEAPP');
  },

  get lxHeaderItemLabelAppModeDate() {
    return Localization.get('bumblesite@LAYOUT.FOOTER.BUMBLE_DATE');
  },

  get lxHeaderItemDescriptionAppModeDate() {
    return Localization.get('bumblesite@layout.header.bumble_date.description');
  },

  get lxHeaderItemLabelAppModeBFF() {
    return Localization.get('bumblesite@LAYOUT.FOOTER.BUMBLE_BFF');
  },

  get lxHeaderItemDescriptionAppModeBFF() {
    return Localization.get('bumblesite@layout.header.bumble_bff.description');
  },

  get lxHeaderItemLabelAppModeBizz() {
    return Localization.get('bumblesite@LAYOUT.FOOTER.BUMBLE_BIZZ');
  },

  get lxHeaderItemDescriptionAppModeBizz() {
    return Localization.get('bumblesite@layout.header.bumble_bizz.description');
  },

  get lxHeaderItemLabelAmbassadors() {
    return Localization.get('bumblesite@LAYOUT.HEADER.AMBASSADORS');
  },

  get lxHeaderItemLabelDate() {
    return Localization.get('bumblesite@layout.header.date');
  },

  get lxHeaderItemLabelFriends() {
    return Localization.get('bumblesite@layout.header.nav.friends');
  },

  get lxHeaderItemLabelStories() {
    return Localization.get('bumblesite@layout.header.stories');
  },

  get lxHeaderItemLabelEvents() {
    return Localization.get('bumblesite@layout.header.events');
  },

  get lxHeaderItemLabelBuzz() {
    return Localization.get('bumblesite@layout.header.buzz');
  },

  get lxHeaderItemLabelSafety() {
    return Localization.get('bumblesite@layout.header.safety');
  },

  get lxHeaderItemLabelSupport() {
    return Localization.get('bumblesite@layout.header.support');
  },

  get lxHeaderItemLabelAbout() {
    return Localization.get('bumblesite@LAYOUT.HEADER.ABOUT');
  },

  get lxA11yNavigationMain() {
    return Localization.get('bumblesite@layout.main.a11y.label');
  },

  get lxHeaderModalDateTitle() {
    return Localization.get('bumblesite@layout.modal.date.title');
  },

  get lxHeaderModalDateDescription() {
    return Localization.get('bumblesite@layout.modal.date.description');
  },

  get lxHeaderModalDateComplimentsTitle() {
    return Localization.get('bumblesite@layout.modal.date.compliments.title');
  },

  get lxHeaderModalDateComplimentsDescription() {
    return Localization.get('bumblesite@layout.modal.date.compliments.description');
  },

  get lxHeaderModalDateIncognitoTitle() {
    return Localization.get('bumblesite@layout.modal.date.incognito.title');
  },

  get lxHeaderModalDateIncognitoDescription() {
    return Localization.get('bumblesite@layout.modal.date.incognito.description');
  },

  get lxHeaderModalDateVideoChatTitle() {
    return Localization.get('bumblesite@layout.modal.date.video_chat.title');
  },

  get lxHeaderModalDateVideoChatDescription() {
    return Localization.get('bumblesite@layout.modal.date.video_chat.description');
  },

  get lxHeaderModalDateSnoozeModeTitle() {
    return Localization.get('bumblesite@layout.modal.date.snooze_mode.title');
  },

  get lxHeaderModalDateSnoozeModeDescription() {
    return Localization.get('bumblesite@layout.modal.date.snooze_mode.description');
  },

  get lxHeaderModalDateTravelModeTitle() {
    return Localization.get('bumblesite@layout.modal.date.travel_mode.title');
  },

  get lxHeaderModalDateTravelModeDescription() {
    return Localization.get('bumblesite@layout.modal.date.travel_mode.description');
  },

  get lxHeaderModalDateSuperSwipeTitle() {
    return Localization.get('bumblesite@layout.modal.date.superswipe.title');
  },
  get lxHeaderModalDateSuperSwipeDescription() {
    return Localization.get('bumblesite@layout.modal.date.superswipe.description');
  },

  get lxHeaderModalFriendsTitle() {
    return Localization.get('bumblesite@layout.modal.friends.title');
  },

  get lxHeaderModalFriendsDescription() {
    return Localization.get('bumblesite@layout.modal.friends.description');
  },

  get lxHeaderModalFriendsPlansTitle() {
    return Localization.get('bumblesite@layout.modal.friends.plans.title');
  },

  get lxHeaderModalFriendsPlansDescription() {
    return Localization.get('bumblesite@layout.modal.friends.plans.description');
  },

  get lxHeaderModalFriendsCommunityLeadersTitle() {
    return Localization.get('bumblesite@layout.modal.friends.community_leaders.title');
  },

  get lxHeaderModalFriendsCommunityLeadersDescription() {
    return Localization.get('bumblesite@layout.modal.friends.community_leaders.description');
  },

  get lxHeaderModalStoriesTitle() {
    return Localization.get('bumblesite@layout.modal.stories.title');
  },

  get lxHeaderModalStoriesDescription() {
    return Localization.get('bumblesite@layout.modal.stories.description');
  },

  get lxHeaderModalStoriesLoveStoriesTitle() {
    return Localization.get('bumblesite@layout.modal.stories.love_stories.title');
  },

  get lxHeaderModalStoriesLoveStoriesDescription() {
    return Localization.get('bumblesite@layout.modal.stories.love_stories.description');
  },

  get lxHeaderModalStoriesSeasonalTitle() {
    return Localization.get('bumblesite@layout.modal.stories.seasonal.title');
  },

  get lxHeaderModalStoriesSeasonalDescription() {
    return Localization.get('bumblesite@layout.modal.stories.seasonal.description');
  },

  get lxHeaderModalStoriesFriendshipHubTitle() {
    return Localization.get('bumblesite@layout.modal.stories.friendship_hub.title');
  },

  get lxHeaderModalStoriesFriendshipHubDescription() {
    return Localization.get('bumblesite@layout.modal.stories.friendship_hub.description');
  },

  get lxHeaderItemLabelFeatures() {
    return Localization.get('bumblesite@layout.header.features');
  },

  get lxHeaderItemLabelFeaturesVideoChat() {
    return Localization.get('bumblesite@layout.header.features.video_chat');
  },

  get lxHeaderItemDescriptionFeaturesVideoChat() {
    return Localization.get('bumblesite@layout.header.features.video_chat.description');
  },

  get lxHeaderItemLabelFeaturesTravelMode() {
    return Localization.get('bumblesite@layout.header.features.travel_mode');
  },

  get lxHeaderItemDescriptionFeaturesTravelMode() {
    return Localization.get('bumblesite@layout.header.features.travel_mode.description');
  },

  get lxHeaderCtaTitleFeaturesTravelMode() {
    return Localization.get('bumblesite@layout.header.cta.title.features.travel_mode');
  },

  get lxHeaderItemLabelFeaturesIncognitoMode() {
    return Localization.get('bumblesite@layout.header.features.incognito_mode');
  },

  get lxHeaderItemDescriptionFeaturesIncognitoMode() {
    return Localization.get('bumblesite@layout.header.features.incognito_mode.description');
  },

  get lxHeaderItemLabelFeaturesSnoozeMode() {
    return Localization.get('bumblesite@layout.header.features.snooze_mode');
  },

  get lxHeaderItemDescriptionFeaturesSnoozeMode() {
    return Localization.get('bumblesite@layout.header.features.snooze_mode.description');
  },

  get lxHeaderItemLabelFeaturesCompliments() {
    return Localization.get('bumblesite@layout.header.features.compliments');
  },

  get lxHeaderItemDescriptionFeaturesCompliments() {
    return Localization.get('bumblesite@layout.header.features.compliments.description');
  },

  get lxHeaderItemLabelFeaturesSuperswipe() {
    return Localization.get('bumblesite@layout.header.features.superswipe');
  },

  get lxHeaderItemDescriptionFeaturesSuperswipe() {
    return Localization.get('bumblesite@layout.header.features.superswipe.description');
  },

  get lxHeaderItemLabelFeaturesInstantMatch() {
    return Localization.get('bumblesite@layout.header.features.instant-match');
  },

  get lxHeaderItemDescriptionFeaturesInstantMatch() {
    return Localization.get('bumblesite@layout.header.features.instant-match.description');
  },
  get lxHeaderItemLabelFeaturesDiscover() {
    return Localization.get('bumblesite@layout.header.features.discover');
  },

  get lxHeaderItemDescriptionFeaturesDiscover() {
    return Localization.get('bumblesite@layout.header.features.discover.description');
  },

  get lxHeaderCtaButtonFindOutMore() {
    return Localization.get('bumblesite@layout.header.cta.find_out_more.button');
  },

  get lxSignIn() {
    return Localization.get('bumblesite@footer.sign_in');
  },

  get lxGetTheApp() {
    return Localization.get('bumblesite@layout.header.get_the_app');
  },

  get lxA11yNavigationMenuOpen() {
    return Localization.get('bumblesite@header.navigation.menu.open.a11y.label');
  },
  get lxA11yNavigationMenuClose() {
    return Localization.get('bumblesite@header.navigation.menu.close.a11y.label');
  },

  get lxA11yDownload() {
    return Localization.get('bumblesite@footer.download_the_app');
  },
};
